import {Section} from "./Section";
import Calendar from "react-calendar";
import {CalendarCustom} from "../calendar/CalendarCustom";
import {useCalendarDatas} from "../../api/calendardatasapi";
import {Button, Col} from "react-bootstrap";
import {useInsurancesBehaviours} from "../../api/insuranceandbehaviourapi";
import {minioBaseUrl} from "../../data/defaultConfig";

export function AsideLeft(props) {
    const {style} = props;
    const {insurancesBehaviours} = useInsurancesBehaviours();
    // id 6 = ethisch charter
    // id 7 = panathlon
    // id 8 = protocol
    const {calendardatas} = useCalendarDatas();
    return <Section title={'Kalender'} className={'p-2'}>
        <Col xs={12}>
            <CalendarCustom small={true} tasks={calendardatas?.map(cd => {
                return {...cd, date: new Date(cd.date)}
            })}/>
        </Col>
        <Section title={"Gedragscodes"} className={"mt-2"}>
            <Col xs={12} className={" mt-2"}>
                <Button href={minioBaseUrl + insurancesBehaviours?.find(ib => ib.id === 6)?.fileinsurancebehavious.url}
                        target={"_blank"} style={{background: "white"}} className={"btn-light p-0"}>
                    <img width={"30%"} src={"/images/code-of-conduct.jpg"} alt={"behaviour code icon"}/>
                    <h6>Ethisch Charter</h6>
                </Button>

            </Col>
            <Col xs={12} className={" mt-2 text-center"}>
                <Button href={minioBaseUrl + insurancesBehaviours?.find(ib => ib.id === 7)?.fileinsurancebehavious.url}
                        target={"_blank"} style={{background: "white"}} className={"btn-light p-0"}>
                    <img width={"30%"} src={"/images/panathlon.png"} alt={"behaviour code icon"}/>
                    <h6>Panathlonverklaring</h6>
                </Button>
            </Col>
            <Col xs={12} className={"mt-2 text-center"}>
                <Button href={minioBaseUrl + insurancesBehaviours?.find(ib => ib.id === 8)?.fileinsurancebehavious.url}
                        target={"_blank"} style={{background: "white"}} className={"btn-light p-0"}>
                    <img width={"30%"} src={"/images/handshakeicon.png"} alt={"behaviour code icon"}/>
                    <h6>Protocol grensoverschrijdend gedrag</h6>
                </Button>
            </Col>
        </Section>

    </Section>
}